export default function ContactInformationSimple({ contact }) {
  if (!contact) return null;

  return (
    <>
      <p>{contact.name}</p>
      <p>{contact.phone}</p>
      <p>{contact.email}</p>
    </>
  );
}
